import * as Yup from "yup";

export const getSchema = () => {

    return Yup.object({

        nombreCompleto: Yup
            .string()
            .trim()
            .required(
                "El nombre o razón social es obligatorio"
            ),

        emailCliente: Yup
            .string()
            .trim()
            .lowercase()
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "El email no es válido"
            )
            .required(
                "El email es obligatorio"
            ),

        telefono: Yup
            .string()
            .trim()
            .matches(
                /^[0-9]*$/,
                "El teléfono solo debe contener números"
            ),

        celular: Yup
            .string()
            .trim()
            .matches(
                /^[0-9]*$/,
                "El celular solo debe contener números"
            )
            .required(
                "El celular es obligatorio"
            ),
        sucursal: Yup
            .mixed()
            .nullable()
            .required(
                "La sucursal es obligatoria"
            )
            .test(
                "sucursal-valida",
                "Debe seleccionar una sucursal válida",
                (value) => {

                    if (!value) {
                        return true;
                    }

                    return (
                        typeof value === "object" &&
                        !!value.nombreSucursal &&
                        !!value.codigoSucursal
                    );
                }
            ),
    });
};